import $gUn4u$react from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $b02497e8694279b1$export$a5f5a6912b18861c(children) {
    let element;
    if (typeof children === 'string') element = /*#__PURE__*/ (0, $gUn4u$react).createElement("span", null, children);
    else element = (0, $gUn4u$react).Children.only(children);
    return element;
}


export {$b02497e8694279b1$export$a5f5a6912b18861c as getWrappedElement};
//# sourceMappingURL=getWrappedElement.mjs.map
